module.exports = __webpack_public_path__ + "media/images/Empath-9f0ce83f726eb821e91cfe0365222b8e.jpg";